var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.02975 24.8806C2.45146 25.3023 3.13673 25.3023 3.55844 24.8806L17.0003 11.4124L30.4685 24.8806C30.8902 25.3023 31.5755 25.3023 31.9972 24.8806C32.4189 24.4589 32.4189 23.7736 31.9972 23.3519L17.791 9.14573C17.5801 8.93488 17.3166 8.82946 17.0267 8.82946C16.7631 8.82946 16.4732 8.93488 16.2623 9.14573L2.05611 23.3519C1.60805 23.7736 1.60805 24.4589 2.02975 24.8806Z",
    fill: "#3D3D3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownarrow);
export default __webpack_public_path__ + "static/media/dropdownarrow.37d9cffe3c9eb77bab0408dfd96abaca.svg";
export { ForwardRef as ReactComponent };